import React                from "react";
import {MaybeHasChildren}   from "./@types";
// slot for custom element
export const Header: React.FC<MaybeHasChildren> = () => null;
